import Graphic from './graphic'
import Color from './color'
import _get from 'lodash/get'
import _isObjectLike from 'lodash/isObjectLike'

// Text Class
export default class {
  constructor (config = {}) {
    this.manifest = {}
    // Guard on truthiness so an undefined manifest (saved design has more
    // texts than the product manifest declares) doesn't clobber the {} default.
    if (config.manifest) {
      this.manifest = config.manifest
    }

    this.text = ''
    this.label = ''
    this.areaIndex = null
    this.areaLabel = ''
    this._path = null
    this.textIndex = null
    this.font = ''
    this.zone = 1
    this.svgPath = null
    this.colorFill = false
    this.maxCharacters = null
    this.objName = ''
    this.enabled = false

    this.graphicProperties = ['prefixGraphic', 'suffixGraphic']

    this.prefixGraphic = null
    this.suffixGraphic = null

    let defaults = {}
    try {
      defaults = config.defaults
    } finally {}

    if (config.hasOwnProperty('textObj')) {
      this.fromObject(config.textObj, defaults)
    }
  }
  fromObject (obj, defaults) {
    // Required fields
    this.areaIndex = obj.areaIndex
    if (typeof this.areaIndex === 'undefined') {
      this.areaIndex = obj.areas_index
    }

    this.areaLabel = obj.areaLabel

    this.textIndex = obj.textIndex
    if (typeof this.textIndex === 'undefined') {
      this.textIndex = obj.texts_index
    }

    this._path = `customization.areas.${this.areaIndex}.texts.${this.textIndex}`

    // Optional fields
    this.text = _get(obj, 'text', '')
    this.label = _get(obj, 'label', `Text ${this.textIndex}`)

    let defaultFont = _get(defaults, 'font', null)
    this.font = _get(obj, 'font', defaultFont)

    this.zone = _get(obj, 'zone', null)
    this.svgPath = _get(obj, 'svgPath', null)

    let recommendedPath = `${this._path}.colorFill`
    let colorConfig = {
      _path: recommendedPath
    }
    let defaultPrintColor = _get(defaults, 'printColor')
    if (defaultPrintColor) {
      Object.assign(colorConfig, defaultPrintColor)
    }

    let defaultColorConfig = _get(obj, 'colorFill', null)
    if (defaultColorConfig) {
      if (_isObjectLike(defaultColorConfig) && _get(defaultColorConfig, 'id')) {
        colorConfig = defaultColorConfig
        if (!_get(colorConfig, '_path')) {
          colorConfig._path = recommendedPath
        }
      }
    }
    this.colorFill = new Color(colorConfig)

    this.maxCharacters = _get(obj, 'maxCharacters', 0)
    this.objName = _get(obj, 'objName', '')
    this.enabled = _get(obj, 'enabled', true)

    for (let i = 0; i < this.graphicProperties.length; i++) {
      if (this.manifestAllowsGraphic(this.graphicProperties[i])) {
        let graphicConfig = {
          manifest: this.manifest[this.graphicProperties[i]],
          defaults,
          graphicObj: Object.assign({
            areaIndex: this.areaIndex,
            areaLabel: this.areaLabel,
            textIndex: this.textIndex,
            graphicIndex: this.graphicProperties[i]
          }, obj[this.graphicProperties[i]])
        }
        this[this.graphicProperties[i]] = new Graphic(graphicConfig)
      }
    }
  }

  manifestAllowsColorFill () {
    if (this.manifest.hasOwnProperty('colorFill')) {
      return this.manifest.colorFill
    }

    return false
  }

  manifestAllowsGraphic (type) {
    return (this.manifest.hasOwnProperty(type))
  }

  hasPrefixGraphic () {
    let prefixImage = _get(this, 'prefixGraphic.image', null)
    return !!prefixImage
  }

  hasSuffixGraphic () {
    let suffixImage = _get(this, 'suffixGraphic.image', null)
    return !!suffixImage
  }

  getPostData () {
    let me = {
      'areas_index': this.areaIndex,
      'areaLabel': this.areaLabel,
      'texts_index': this.textIndex,
      'label': this.label,
      'text': this.text,
      'font': this.font,
      'colorFill': this.colorFill,
      'zone': this.zone,
      'svgPath': this.svgPath,
      'maxCharacters': this.maxCharacters,
      'objName': this.objName,
      'prefixGraphic': null,
      'suffixGraphic': null
    }

    if (this.hasPrefixGraphic()) {
      me.prefixGraphic = this.prefixGraphic.getPostData()
    }

    if (this.hasSuffixGraphic()) {
      me.suffixGraphic = this.suffixGraphic.getPostData()
    }

    return me
  }
}
